import { Injectable, inject } from '@angular/core';

import { UserService } from '../data-services/user.service'; // Assuming path is correct, adjust if needed
import { AIAPI, Endpoints } from '../enums'; // Assuming path is correct, adjust if needed
import { LearningExample } from '../lexicore/lexicore.classes';
import { HttpService } from '../system/http.service'; // Assuming path is correct, adjust if needed

@Injectable({
  providedIn: 'root',
})
export class WordGenerationService {
  private httpService = inject(HttpService);
  private userService = inject(UserService);

  public async generateLearningExample(word: string): Promise<LearningExample> {
    const langString = this.userService.getUserLangOptions();
    return await this.httpService.getDataFromService(`${AIAPI.GenerateExample}/${word}?${langString}`, 'python');
  }

  public async generateQuickPhrases(word: string, learningExampleId: string): Promise<LearningExample[]> {
    const langString = this.userService.getUserLangOptions();
    const body = {
      word,
      learningExampleId,
    };

    return await this.httpService.postDataToService(`${Endpoints.Lexicore.Generation.QuickPhrases}?${langString}`, body, 'node');
  }

  public async generateWordAudio(word: string): Promise<unknown> {
    const langString = this.userService.getUserLangOptions();
    return await this.httpService.getDataFromService(`${AIAPI.GenerateWordAudio}/${word}?${langString}`, 'python');
  }

  public async generateAIExamples(word: string): Promise<unknown[]> {
    return await this.httpService.getDataFromService(`${AIAPI.GenerateExamples}/${word}`, 'python');
  }
}
